import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../pages/Login'
import Main from '../pages/Main'
import Index from '../pages/Index'
import All from '../pages/All'
import Archive from '../pages/Archive'
import News from '../pages/News'
import List from '../pages/List'
import SSO from '../pages/SSO'
import Contravention from '../pages/Contravention'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '',
    name: 'Index',
    meta: { auth: true },
    component: Index,
    children: [
      {
        path: '/',
        name: 'Main',
        component: Main
      },
      {
        path: '/News',
        name: 'News',
        component: News
      },
      {
        path: '/archive',
        name: 'Archive',
        component: All,
        children: [
          {
            path: ':id',
            component: Archive
          }
        ]
      },
      {
        path: '/contravention',
        name: 'List',
        component: List,
        children: [
          {
            path: ':id',
            name: 'Contravention',
            component: Contravention
          }
        ]
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/x1sso',
    name: 'SSOAuth',
    component: SSO
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.auth)) {
    if (!store.getters.isAuth) {
      next({
        name: 'Login',
        query: { redirect: to.fullPath }
      })
    }
    else {
      next()
    }
  } else {
    next()
  }
})

export default router
